export const API_BASE_URL = 'https://apis.crypton.media/api'
export const getApiUrl = (endpoint) => API_BASE_URL + endpoint;
// authentication
export const SIGN_UP = getApiUrl('sign-up');
export const PROFILE = getApiUrl('profile');
export const ASSETS = getApiUrl('assets');
export const LOGIN = getApiUrl('login');